/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Country } from './Country';
import {
    CountryFromJSON,
    CountryFromJSONTyped,
    CountryToJSON,
    CountryToJSONTyped,
} from './Country';

/**
 * Postal address details.
 * @export
 * @interface PostalAddress
 */
export interface PostalAddress {
    /**
     * From https://schema.org/Person : The locality in which the street address is, and which is in the region. For example, Mountain View.
     * @type {string}
     * @memberof PostalAddress
     */
    addressLocality?: string;
    /**
     * From https://schema.org/Person : The region in which the locality is, and which is in the country. For example, California or another appropriate first-level Administrative division.
     * @type {string}
     * @memberof PostalAddress
     */
    addressRegion?: string;
    /**
     * From https://schema.org/Person : The post office box number for PO box addresses.
     * @type {string}
     * @memberof PostalAddress
     */
    postOfficeBoxNumber?: string;
    /**
     * From https://schema.org/Person : The postal code. For example, 94043.
     * @type {string}
     * @memberof PostalAddress
     */
    postalCode?: string;
    /**
     * The street address that can be on several lines. Usually there are one or two address lines, however there could be more. For example, 1600 Amphitheatre Pkwy.
     * @type {Array<string>}
     * @memberof PostalAddress
     */
    addressLines?: Array<string>;
    /**
     * Country details.
     * @type {Country}
     * @memberof PostalAddress
     */
    addressCountry?: Country;
}

/**
 * Check if a given object implements the PostalAddress interface.
 */
export function instanceOfPostalAddress(value: object): value is PostalAddress {
    return true;
}

export function PostalAddressFromJSON(json: any): PostalAddress {
    return PostalAddressFromJSONTyped(json, false);
}

export function PostalAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostalAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'addressLocality': json['addressLocality'] == null ? undefined : json['addressLocality'],
        'addressRegion': json['addressRegion'] == null ? undefined : json['addressRegion'],
        'postOfficeBoxNumber': json['postOfficeBoxNumber'] == null ? undefined : json['postOfficeBoxNumber'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'addressLines': json['addressLines'] == null ? undefined : json['addressLines'],
        'addressCountry': json['addressCountry'] == null ? undefined : CountryFromJSON(json['addressCountry']),
    };
}

export function PostalAddressToJSON(json: any): PostalAddress {
    return PostalAddressToJSONTyped(json, false);
}

export function PostalAddressToJSONTyped(value?: PostalAddress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'addressLocality': value['addressLocality'],
        'addressRegion': value['addressRegion'],
        'postOfficeBoxNumber': value['postOfficeBoxNumber'],
        'postalCode': value['postalCode'],
        'addressLines': value['addressLines'],
        'addressCountry': CountryToJSON(value['addressCountry']),
    };
}

